import styled from 'styled-components';

export const Subtitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 2px;

  @media screen and (max-width: 960px) {
    margin-bottom: 4px;
    font-size: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 624px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  padding: 10px 30px;
  margin-bottom: 12px;

  @media screen and (max-width: 960px) {
    display: flex;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 16px;
    flex-wrap: wrap;

    .mobile-1 {
      order: 1;
    }

    .mobile-2 {
      order: 2;
      width: 70%;
    }

    .mobile-3 {
      order: 3;
    }

    .mobile-4 {
      order: 4;
    }
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 55%;

  .number {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  .bank-name {
    font-weight: 700;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 2px;
  }

  .default {
    display: flex;
    font-weight: 400;
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
    line-height: 130%;
    span {
      margin-left: 2px;
    }
  }

  .default2 {
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;

    span {
      font-weight: 700;
    }
  }

  .space-right {
    margin-right: 4px;
  }

  .space-left {
    margin-left: 4px;
  }

  .contentText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0px 15px;
  }

  .spanContent {
    margin-bottom: 2px;
    color: ${(props) => props.theme.colors.gray};
    font-size: 12px;
  }

  .contentInfo {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    width: 70%;

    ::after {
      content: '';
      display: block;
      height: 8px;
      width: 100%;
    }

    .number {
      font-size: 20px;
    }

    .bank-name {
      font-size: 16px;
    }

    .default {
      order: 2;
      font-size: 12px;
    }

    .default2 {
      order: 1;
      font-size: 14px;
    }

    div {
      /* margin-left: 4px; */
    }

    .contentInfo {
      flex-direction: column;
    }
  }
`;

export const PlanContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius) ? `${props.theme.borderRadius}px` : '5px'};
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  font-size: 11px;
  padding: 8px;
  font-weight: 400;
  text-align: center;
  width: 48px;
  height: 48px;

  span {
    font-size: 16px;
    font-weight: 700;
  }

  @media screen and (max-width: 768px) {
    order: 3;
    width: 56px;
    height: 56px;

    div {
      margin-top: 8px;
      width: auto;
      height: auto;
      padding: 8px 12px;

      span {
        font-size: 14px;
      }
    }
  }
`;
